/**
 * i18n Configuration — react-i18next with browser language detection
 *
 * Supports EFIGS (English, French, Italian, German, Spanish)
 * Detection order: localStorage → navigator → fallback to English
 */

import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "@/locales/en.json";
import fr from "@/locales/fr.json";
import it from "@/locales/it.json";
import de from "@/locales/de.json";
import es from "@/locales/es.json";

export const STORAGE_KEY = "vizimix-language";

export const supportedLanguages = ["en", "fr", "it", "de", "es"] as const;
export type SupportedLanguage = (typeof supportedLanguages)[number];

export const languageNames: Record<SupportedLanguage, string> = {
  en: "English",
  fr: "Fran\u00e7ais",
  it: "Italiano",
  de: "Deutsch",
  es: "Espa\u00f1ol",
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
      it: { translation: it },
      de: { translation: de },
      es: { translation: es },
    },
    fallbackLng: "en",
    supportedLngs: supportedLanguages as unknown as string[],
    interpolation: {
      escapeValue: false, // React already handles XSS
    },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: STORAGE_KEY,
      caches: ["localStorage"],
    },
  });

export default i18n;
